import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const NAVY = '#1a2a4a';
const GOLD = '#b8860b';
const DEFAULT_WA = '201008182425';

const DEFAULT_STATS = [
  ['Band 7.0+', 'Average Score'],
  ['Egypt & Gulf', 'Region'],
  ['18+', 'Expert Trainers'],
  ['4–5 Weeks', 'To Band 7+'],
];

function StarRating({ rating }) {
  return (
    <span>
      {[1,2,3,4,5].map(i => (
        <span key={i} style={{ color: i <= rating ? '#f59e0b' : '#d1d5db', fontSize:16 }}>★</span>
      ))}
    </span>
  );
}

function NavBar({ onLogin, onRegister, onTrial, onAcademy, logoUrl, academyName }) {
  return (
    <nav style={{ background:'#fff', borderBottom:`1px solid #e8edf5`, padding:'0 24px', position:'sticky', top:0, zIndex:1000, boxShadow:'0 1px 8px rgba(26,42,74,0.08)' }}>
      <div style={{ maxWidth:1100, margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'space-between', height:64 }}>
        <a href="#home" style={{ display:'flex', alignItems:'center', gap:12, textDecoration:'none' }}>
          <img src={logoUrl || '/logo.png'} alt="logo" style={{ height:38, objectFit:'contain' }}/>
          <span style={{ fontFamily:"'JetBrains Mono',monospace", fontWeight:700, fontSize:16, color:NAVY }}>{academyName || 'Compass Academy'}</span>
        </a>
        <div className="lp-nav-links" style={{ display:'flex', alignItems:'center', gap:20 }}>
          {['Home','Courses','Results','Contact'].map(l => (
            <a key={l} href={`#${l.toLowerCase()}`} style={{ color:'#5a6a88', fontSize:14, textDecoration:'none', fontFamily:"'Plus Jakarta Sans',sans-serif" }}
              onMouseEnter={e=>e.target.style.color=NAVY} onMouseLeave={e=>e.target.style.color='#5a6a88'}>{l}</a>
          ))}
          {onAcademy && (
            <button onClick={onAcademy} style={{ background:'none', border:'none', color:'#5a6a88', fontSize:14, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", padding:0 }}
              onMouseEnter={e=>e.target.style.color=NAVY} onMouseLeave={e=>e.target.style.color='#5a6a88'}>
              Student Portal
            </button>
          )}
        </div>
        <div className="lp-nav-actions" style={{ display:'flex', gap:8, alignItems:'center' }}>
          <button onClick={onLogin} style={{ padding:'8px 18px', borderRadius:8, border:`1.5px solid ${NAVY}`, background:'transparent', color:NAVY, fontSize:13.5, fontWeight:600, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
            Log In
          </button>
          <button onClick={onRegister} style={{ padding:'8px 18px', borderRadius:8, border:`1.5px solid ${GOLD}`, background:'transparent', color:GOLD, fontSize:13.5, fontWeight:600, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
            Register
          </button>
          <button onClick={onTrial} style={{ padding:'8px 18px', borderRadius:8, border:'none', background:'#25d366', color:'#fff', fontSize:13.5, fontWeight:600, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
            Start Free Trial
          </button>
        </div>
      </div>
    </nav>
  );
}

function HeroSection({ onTrial, stats }) {
  const displayStats = stats && stats.length === 4 ? stats : DEFAULT_STATS;
  return (
    <section id="home" style={{ background:`linear-gradient(135deg,${NAVY} 0%,#2a3a6a 60%,${NAVY} 100%)`, padding:'80px 24px 64px', textAlign:'center', position:'relative', overflow:'hidden' }}>
      <div style={{ position:'absolute', inset:0, background:'radial-gradient(ellipse at 50% 0%,rgba(184,134,11,0.18) 0%,transparent 60%)', pointerEvents:'none' }}/>
      <div style={{ maxWidth:760, margin:'0 auto', position:'relative' }}>
        <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, letterSpacing:'.18em', textTransform:'uppercase', color:GOLD, marginBottom:16 }}>
          Compass Academy · IELTS Preparation
        </div>
        <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:'clamp(28px,5vw,52px)', fontWeight:700, color:'#fff', lineHeight:1.15, marginBottom:20 }}>
          Achieve Your Target<br/><em style={{ color:'#d4a017' }}>IELTS Band Score</em>
        </h1>
        <p style={{ fontSize:16, color:'rgba(255,255,255,0.72)', lineHeight:1.75, marginBottom:36, maxWidth:600, margin:'0 auto 36px' }}>
          Expert-guided preparation with AI-powered writing feedback, live lessons, and personalised coaching by Mr. Ahmed Salem
        </p>
        <div style={{ display:'flex', gap:14, justifyContent:'center', flexWrap:'wrap', marginBottom:48 }}>
          <button onClick={onTrial} style={{ padding:'14px 32px', borderRadius:10, border:'none', background:`linear-gradient(135deg,${GOLD},#d4a017)`, color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer', boxShadow:`0 4px 20px rgba(184,134,11,0.4)`, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
            Start Free Trial →
          </button>
          <a href="#results" style={{ padding:'14px 32px', borderRadius:10, border:'2px solid rgba(255,255,255,0.4)', background:'transparent', color:'#fff', fontSize:15, fontWeight:600, cursor:'pointer', textDecoration:'none', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
            See Student Results
          </a>
        </div>
        <div style={{ display:'flex', gap:32, justifyContent:'center', flexWrap:'wrap' }}>
          {displayStats.map(([n,l]) => (
            <div key={l} style={{ textAlign:'center' }}>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:26, fontWeight:700, color:'#d4a017' }}>{n}</div>
              <div style={{ fontSize:12, color:'rgba(255,255,255,0.55)', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>{l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function HowItWorksSection() {
  const steps = [
    { icon:'🤖', title:'Practice with AI', desc:'Get instant Smart Writing feedback on your essays — task achievement, coherence, lexical resource, grammar — all scored and explained.' },
    { icon:'👨‍🏫', title:'Learn with Experts', desc:'Live Zoom sessions with certified IELTS trainers. Personalised coaching from Mr. Ahmed Salem and our team.' },
    { icon:'📈', title:'Track Your Progress', desc:'Watch your band score improve over time with visual progress charts and detailed session history.' },
  ];
  return (
    <section style={{ padding:'72px 24px', background:'#f8fafc' }}>
      <div style={{ maxWidth:900, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, letterSpacing:'.15em', color:GOLD, textTransform:'uppercase', marginBottom:10 }}>How It Works</div>
          <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:700, color:NAVY }}>Your Path to Band 7+</h2>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(240px,1fr))', gap:28 }}>
          {steps.map((s,i) => (
            <div key={i} style={{ background:'#fff', border:'1px solid #e8edf5', borderRadius:16, padding:'32px 24px', textAlign:'center', boxShadow:'0 2px 12px rgba(26,42,74,0.06)' }}>
              <div style={{ fontSize:38, marginBottom:16 }}>{s.icon}</div>
              <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.1em', color:GOLD, textTransform:'uppercase', marginBottom:8 }}>Step {i+1}</div>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:20, fontWeight:700, color:NAVY, marginBottom:12 }}>{s.title}</div>
              <div style={{ fontSize:13.5, color:'#5a6a88', lineHeight:1.7 }}>{s.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CoursesSection({ waNumber }) {
  const wa = waNumber || DEFAULT_WA;
  const GROUPS = [
    {
      icon: '📘', title: 'General English', subtitle: 'A1 to C1 · All levels welcome',
      color: '#2196F3', bg: '#f0f6ff', border: '#c0d8f8',
      desc: 'Structured courses from absolute beginner to advanced. Whether you need English for work, daily life, or as a stepping stone to IELTS — we have a programme for you.',
      points: ['Beginner (A1) through Advanced (C1)','Private 1-on-1 or small group classes','Flexible scheduling — daytime and evening','Grammar, vocabulary, speaking & writing'],
      waMsg: 'Hello Mr. Ahmed Salem! I am interested in General English courses. Please contact me to discuss the right level and schedule.',
    },
    {
      icon: '🎯', title: 'IELTS Preparation', subtitle: '5–6 week intensive · All 4 skills',
      color: '#b8860b', bg: 'linear-gradient(135deg,#1a2a4a,#2a3a6a)', border: '#b8860b',
      dark: true,
      desc: 'Targeted preparation for Band 6.0–8.0. Covers Reading, Listening, Writing and Speaking with AI-powered feedback, mock exams, and expert coaching by Mr. Ahmed Salem.',
      points: ['Writing Task 1 & 2 with AI feedback per paragraph','Speaking mock exams with certified examiner','Full mock test under timed conditions','Private or group classes available'],
      waMsg: 'Hello Mr. Ahmed Salem! I am interested in IELTS Preparation. Please contact me to discuss enrolment.',
    },
    {
      icon: '📐', title: 'SAT Preparation', subtitle: 'SAT English & SAT Math',
      color: '#5a1a8a', bg: '#f5ebff', border: '#e0c8f8',
      desc: 'Comprehensive SAT preparation covering both English and Mathematics. Structured practice, past paper techniques, and score improvement strategies.',
      points: ['SAT English: Reading & Writing','SAT Math: Algebra, Data Analysis, Advanced Math','Full practice tests under exam conditions','Personalised score improvement plan'],
      waMsg: 'Hello Mr. Ahmed Salem! I am interested in SAT Preparation. Please contact me to discuss enrolment.',
    },
    {
      icon: '💼', title: 'Specialist Courses', subtitle: 'German · Interview Prep · Speaking',
      color: '#0a6a7a', bg: '#e8f8fb', border: '#c0e8f0',
      desc: 'Focused short courses for specific goals — job interviews in English, spoken fluency and pronunciation, or German language from beginner to advanced.',
      points: ['German language (A1–C1)','Interview Preparation in English','Speaking & Fluency — pronunciation & confidence','Customised one-to-one programmes'],
      waMsg: 'Hello Mr. Ahmed Salem! I am interested in your specialist courses. Please contact me to discuss what would suit me best.',
    },
  ];

  return (
    <section id="courses" style={{ padding:'72px 24px', background:'#fff' }}>
      <div style={{ maxWidth:1000, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, letterSpacing:'.15em', color:GOLD, textTransform:'uppercase', marginBottom:10 }}>Our Programmes</div>
          <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:700, color:NAVY }}>Choose Your Course</h2>
          <p style={{ fontSize:14, color:'#5a6a88', marginTop:12, maxWidth:560, margin:'12px auto 0' }}>All courses are available as private 1-on-1 or small group. Contact Mr. Ahmed on WhatsApp for pricing and scheduling.</p>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))', gap:24 }}>
          {GROUPS.map(g => (
            <div key={g.title} style={{ background: g.bg, border:`2px solid ${g.border}`, borderRadius:16, padding:'28px 24px', display:'flex', flexDirection:'column', boxShadow: g.dark ? '0 6px 28px rgba(26,42,74,0.22)' : '0 2px 12px rgba(26,42,74,0.07)' }}>
              <div style={{ fontSize:38, marginBottom:12 }}>{g.icon}</div>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:700, color: g.dark ? '#fff' : NAVY, marginBottom:4 }}>{g.title}</div>
              <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, color: g.dark ? GOLD : g.color, marginBottom:12, letterSpacing:'.05em' }}>{g.subtitle}</div>
              <div style={{ fontSize:13, color: g.dark ? 'rgba(255,255,255,0.7)' : '#5a6a88', lineHeight:1.7, marginBottom:16 }}>{g.desc}</div>
              <ul style={{ listStyle:'none', margin:'0 0 20px', padding:0, flex:1 }}>
                {g.points.map((p,i) => (
                  <li key={i} style={{ display:'flex', alignItems:'flex-start', gap:8, marginBottom:8 }}>
                    <span style={{ color:'#25d366', flexShrink:0, marginTop:1 }}>✓</span>
                    <span style={{ fontSize:13, color: g.dark ? 'rgba(255,255,255,0.8)' : '#374151', lineHeight:1.5 }}>{p}</span>
                  </li>
                ))}
              </ul>
              <a href={`https://wa.me/${wa}?text=${encodeURIComponent(g.waMsg)}`} target="_blank" rel="noreferrer"
                style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, padding:'12px 0', borderRadius:9, background:'#25d366', color:'#fff', fontSize:14, fontWeight:700, textDecoration:'none', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
                📲 Enquire on WhatsApp
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ResultsSection({ results }) {
  return (
    <section id="results" style={{ padding:'72px 24px', background:'#f0f4f8' }}>
      <div style={{ maxWidth:1000, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, letterSpacing:'.15em', color:GOLD, textTransform:'uppercase', marginBottom:10 }}>Proven Results</div>
          <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:700, color:NAVY }}>Student Score Improvements</h2>
        </div>
        {results.length === 0 && (
          <div style={{ textAlign:'center', color:'#9aa3b8', fontSize:14, padding:20 }}>Student results coming soon…</div>
        )}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:20 }}>
          {results.filter(r=>r.is_featured).slice(0,6).map(r => (
            <div key={r.id} style={{ background:'#fff', border:'1px solid #e8edf5', borderRadius:14, padding:'20px', boxShadow:'0 2px 10px rgba(26,42,74,0.06)' }}>
              {r.screenshot_url && <img src={r.screenshot_url} alt="result" style={{ width:'100%', borderRadius:8, marginBottom:14, objectFit:'cover', height:120 }}/>}
              <div style={{ display:'flex', gap:14, justifyContent:'center', marginBottom:12 }}>
                <div style={{ textAlign:'center', background:'#fff5f5', border:'1px solid #fecdd3', borderRadius:8, padding:'8px 16px' }}>
                  <div style={{ fontSize:11, color:'#9ca3af', fontFamily:"'JetBrains Mono',monospace" }}>BEFORE</div>
                  <div style={{ fontSize:22, fontWeight:700, color:'#dc2626', fontFamily:"'Cormorant Garamond',serif" }}>{r.before_score}</div>
                </div>
                <div style={{ display:'flex', alignItems:'center', fontSize:20 }}>→</div>
                <div style={{ textAlign:'center', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:'8px 16px' }}>
                  <div style={{ fontSize:11, color:'#9ca3af', fontFamily:"'JetBrains Mono',monospace" }}>AFTER</div>
                  <div style={{ fontSize:22, fontWeight:700, color:'#16a34a', fontFamily:"'Cormorant Garamond',serif" }}>{r.after_score}</div>
                </div>
              </div>
              <div style={{ fontWeight:600, color:NAVY, fontSize:14, marginBottom:4 }}>{r.student_name}</div>
              {r.country && <div style={{ fontSize:12, color:'#9aa3b8', marginBottom:8 }}>{r.country}</div>}
              {r.comment && <div style={{ fontSize:12.5, color:'#5a6a88', fontStyle:'italic', lineHeight:1.6 }}>"{r.comment}"</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function PricingSection({ tiers, onTrial, waNumber }) {
  const wa = waNumber || DEFAULT_WA;
  return (
    <section id="pricing" style={{ padding:'72px 24px', background:'#fff' }}>
      <div style={{ maxWidth:1000, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, letterSpacing:'.15em', color:GOLD, textTransform:'uppercase', marginBottom:10 }}>Pricing</div>
          <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:700, color:NAVY }}>Simple, Transparent Pricing</h2>
        </div>
        {tiers.length === 0 && (
          <div style={{ textAlign:'center', color:'#9aa3b8', fontSize:14 }}>Loading pricing…</div>
        )}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))', gap:24 }}>
          {tiers.filter(t=>t.is_active).sort((a,b)=>a.sort_order-b.sort_order).map((tier, idx) => {
            const isPopular = idx === 1;
            const features = Array.isArray(tier.features) ? tier.features : (typeof tier.features === 'string' ? (() => { try { return JSON.parse(tier.features || '[]'); } catch { return []; } })() : []);
            return (
              <div key={tier.id} style={{ border:`2px solid ${isPopular?GOLD:'#e8edf5'}`, borderRadius:16, padding:'28px 24px', position:'relative', boxShadow:isPopular?`0 8px 32px rgba(184,134,11,0.18)`:'0 2px 12px rgba(26,42,74,0.06)', background:isPopular?`linear-gradient(135deg,${NAVY},#2a3a6a)`:'#fff' }}>
                {isPopular && <div style={{ position:'absolute', top:-14, left:'50%', transform:'translateX(-50%)', background:GOLD, color:'#fff', fontSize:11, fontWeight:700, padding:'4px 14px', borderRadius:100, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.06em', whiteSpace:'nowrap' }}>MOST POPULAR</div>}
                <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:700, color:isPopular?'#fff':NAVY, marginBottom:4 }}>{tier.name}</div>
                {tier.show_price !== false ? (
                  <div style={{ display:'flex', alignItems:'baseline', gap:4, marginBottom:6 }}>
                    <span style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:32, fontWeight:700, color:isPopular?'#d4a017':GOLD }}>{tier.price}</span>
                    <span style={{ fontSize:14, color:isPopular?'rgba(255,255,255,0.6)':'#9aa3b8' }}>{tier.currency}</span>
                  </div>
                ) : (
                  <div style={{ fontSize:14, fontStyle:'italic', color:isPopular?'rgba(255,255,255,0.65)':'#9aa3b8', marginBottom:6 }}>Contact for pricing</div>
                )}
                <div style={{ fontSize:12.5, color:isPopular?'rgba(255,255,255,0.55)':'#9aa3b8', marginBottom:20 }}>
                  {tier.duration_unit === 'unlimited' ? 'Unlimited access' : `${tier.duration_value} ${tier.duration_unit}`}
                </div>
                <div style={{ marginBottom:24 }}>
                  {features.map((f,fi) => (
                    <div key={fi} style={{ display:'flex', alignItems:'flex-start', gap:8, marginBottom:10 }}>
                      <span style={{ color:'#25d366', fontSize:14, flexShrink:0, marginTop:1 }}>✓</span>
                      <span style={{ fontSize:13, color:isPopular?'rgba(255,255,255,0.8)':'#374151', lineHeight:1.5 }}>{f}</span>
                    </div>
                  ))}
                </div>
                <a href={`https://wa.me/${wa}?text=${encodeURIComponent(tier.whatsapp_message || `I want to enrol in ${tier.name}${tier.show_price !== false ? ` — ${tier.price} ${tier.currency}` : ''}`)}`} target="_blank" rel="noreferrer"
                  style={{ display:'block', width:'100%', boxSizing:'border-box', padding:'12px 0', borderRadius:9, border:'none', background:isPopular?'#25d366':NAVY, color:'#fff', fontSize:14, fontWeight:700, cursor:'pointer', textDecoration:'none', textAlign:'center', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
                  📲 Get Started via WhatsApp
                </a>
              </div>
            );
          })}
        </div>
        <div style={{ textAlign:'center', marginTop:32 }}>
          <div style={{ fontSize:13, color:'#9aa3b8', marginBottom:12 }}>Not sure which plan? Try for free first.</div>
          <button onClick={onTrial} style={{ padding:'11px 28px', background:`linear-gradient(135deg,${GOLD},#d4a017)`, color:'#fff', border:'none', borderRadius:9, fontSize:14, fontWeight:700, cursor:'pointer' }}>
            Start Free Trial →
          </button>
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection({ testimonials }) {
  const COUNTRY_FLAGS = { Egypt:'🇪🇬', UAE:'🇦🇪', 'Saudi Arabia':'🇸🇦', Qatar:'🇶🇦', Kuwait:'🇰🇼', UK:'🇬🇧', Other:'🌍' };
  return (
    <section style={{ padding:'72px 24px', background:'#f8fafc' }}>
      <div style={{ maxWidth:900, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, letterSpacing:'.15em', color:GOLD, textTransform:'uppercase', marginBottom:10 }}>Testimonials</div>
          <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:700, color:NAVY }}>What Students Say</h2>
        </div>
        {testimonials.length === 0 && (
          <div style={{ textAlign:'center', color:'#9aa3b8', fontSize:14 }}>Testimonials coming soon…</div>
        )}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:20 }}>
          {testimonials.filter(t=>t.is_featured).slice(0,6).map(t => (
            <div key={t.id} style={{ background:'#fff', border:'1px solid #e8edf5', borderRadius:14, padding:'24px', boxShadow:'0 2px 10px rgba(26,42,74,0.06)' }}>
              <StarRating rating={t.rating}/>
              <div style={{ fontSize:13.5, color:'#374151', lineHeight:1.7, margin:'12px 0 16px', fontStyle:'italic' }}>"{t.text}"</div>
              <div style={{ fontWeight:600, color:NAVY, fontSize:13.5 }}>
                {COUNTRY_FLAGS[t.country] || '🌍'} {t.student_name}
              </div>
              {t.country && <div style={{ fontSize:12, color:'#9aa3b8' }}>{t.country}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactSection({ waNumber, waNumber2 }) {
  const wa1 = waNumber || DEFAULT_WA;
  const [form, setForm] = useState({ name:'', email:'', message:'' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    if (!form.name.trim() || !form.message.trim()) return;
    setLoading(true);
    try {
      await supabase.from('enquiries').insert({ name:form.name.trim(), email:form.email.trim(), message:form.message.trim() });
      setSent(true);
    } catch {}
    setLoading(false);
  }

  return (
    <section id="contact" style={{ padding:'72px 24px', background:`linear-gradient(135deg,${NAVY},#2a3a6a)` }}>
      <div style={{ maxWidth:640, margin:'0 auto', textAlign:'center' }}>
        <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:11, letterSpacing:'.15em', color:GOLD, textTransform:'uppercase', marginBottom:10 }}>Contact</div>
        <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:700, color:'#fff', marginBottom:16 }}>Ready to Start?</h2>
        <p style={{ fontSize:14, color:'rgba(255,255,255,0.65)', marginBottom:36, lineHeight:1.7 }}>
          Message us on WhatsApp or fill in the form below. Mr. Ahmed will reply within 24 hours.
        </p>
        <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap', marginBottom:40 }}>
          <a href={`https://wa.me/${wa1}`} target="_blank" rel="noreferrer"
            style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'12px 24px', background:'#25d366', color:'#fff', borderRadius:9, fontSize:14, fontWeight:700, textDecoration:'none' }}>
            💬 WhatsApp {waNumber2 ? '(Egypt)' : 'Mr. Ahmed'}
          </a>
          {waNumber2 && (
            <a href={`https://wa.me/${waNumber2}`} target="_blank" rel="noreferrer"
              style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'12px 24px', background:'#25d366', color:'#fff', borderRadius:9, fontSize:14, fontWeight:700, textDecoration:'none' }}>
              💬 WhatsApp (UAE)
            </a>
          )}
          <a href="mailto:admin@ieltscompass.com"
            style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'12px 24px', border:'2px solid rgba(255,255,255,0.3)', color:'#fff', borderRadius:9, fontSize:14, fontWeight:600, textDecoration:'none' }}>
            ✉️ admin@ieltscompass.com
          </a>
        </div>
        {sent ? (
          <div style={{ background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.2)', borderRadius:12, padding:24, color:'#fff' }}>
            ✅ Message received! We'll get back to you soon.
          </div>
        ) : (
          <div style={{ background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:16, padding:'28px 24px', textAlign:'left' }}>
            <input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Your name *"
              style={{ width:'100%', boxSizing:'border-box', padding:'11px 14px', borderRadius:8, border:'1px solid rgba(255,255,255,0.2)', background:'rgba(255,255,255,0.1)', color:'#fff', fontSize:14, marginBottom:12, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none' }}/>
            <input value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="Email address (optional)"
              style={{ width:'100%', boxSizing:'border-box', padding:'11px 14px', borderRadius:8, border:'1px solid rgba(255,255,255,0.2)', background:'rgba(255,255,255,0.1)', color:'#fff', fontSize:14, marginBottom:12, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none' }}/>
            <textarea value={form.message} onChange={e=>setForm(f=>({...f,message:e.target.value}))} placeholder="Your message *" rows={4}
              style={{ width:'100%', boxSizing:'border-box', padding:'11px 14px', borderRadius:8, border:'1px solid rgba(255,255,255,0.2)', background:'rgba(255,255,255,0.1)', color:'#fff', fontSize:14, marginBottom:16, fontFamily:"'Plus Jakarta Sans',sans-serif", resize:'vertical', outline:'none' }}/>
            <button onClick={handleSubmit} disabled={loading || !form.name.trim() || !form.message.trim()}
              style={{ width:'100%', padding:'12px 0', background:GOLD, color:'#fff', border:'none', borderRadius:9, fontSize:14, fontWeight:700, cursor:'pointer', opacity:(loading||!form.name.trim()||!form.message.trim())?0.6:1 }}>
              {loading ? 'Sending…' : 'Send Message →'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

function Footer({ onTerms, onPrivacy, onAcademy, academyName }) {
  return (
    <footer style={{ background:'#111827', padding:'32px 24px', textAlign:'center' }}>
      <div style={{ maxWidth:900, margin:'0 auto' }}>
        <div style={{ fontFamily:"'JetBrains Mono',monospace", fontWeight:700, color:'#fff', fontSize:15, marginBottom:16 }}>
          {academyName || 'Compass Academy'}
        </div>
        <div style={{ display:'flex', gap:20, justifyContent:'center', flexWrap:'wrap', marginBottom:20 }}>
          {['Home','Courses','Results','Contact'].map(l => (
            <a key={l} href={`#${l.toLowerCase()}`} style={{ color:'#9ca3af', fontSize:13, textDecoration:'none' }}>{l}</a>
          ))}
          {onAcademy && (
            <button onClick={onAcademy} style={{ background:'none', border:'none', color:'#9ca3af', fontSize:13, cursor:'pointer', padding:0 }}>Student Portal</button>
          )}
          <button onClick={onTerms} style={{ background:'none', border:'none', color:'#9ca3af', fontSize:13, cursor:'pointer', padding:0 }}>Terms</button>
          <button onClick={onPrivacy} style={{ background:'none', border:'none', color:'#9ca3af', fontSize:13, cursor:'pointer', padding:0 }}>Privacy</button>
        </div>
        <div style={{ fontSize:12, color:'#4b5563' }}>© {new Date().getFullYear()} Compass Academy. All rights reserved.</div>
      </div>
    </footer>
  );
}

export default function LandingPage({ onLogin, onRegister, onTrial, onTerms, onPrivacy, onAcademy, branding }) {
  const [courses,      setCourses]      = useState([]);
  const [results,      setResults]      = useState([]);
  const [tiers,        setTiers]        = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [settings,     setSettings]     = useState({});

  useEffect(() => {
    async function load() {
      const [c, r, t, tm, s] = await Promise.all([
        supabase.from('courses').select('id,name,description,icon,color,bg_color,border_color,cefr_level,cover_image_url,sort_order').eq('active', true).order('sort_order'),
        supabase.from('student_results').select('*').order('sort_order'),
        supabase.from('subscription_tiers').select('*').eq('is_active', true).order('sort_order'),
        supabase.from('testimonials').select('*').order('created_at', { ascending:false }),
        supabase.from('academy_settings').select('*').order('updated_at', { ascending: false }),
      ]);
      setCourses(c.data || []);
      setResults(r.data || []);
      setTiers(t.data || []);
      setTestimonials(tm.data || []);
      const map = {};
      // Newest-first; first occurrence wins
      (s.data || []).forEach(row => { if (!(row.setting_key in map)) map[row.setting_key] = row.setting_value; });
      setSettings(map);
    }
    load();
  }, []);

  // Build hero stats from settings, fall back to defaults
  const heroStats = (() => {
    const s = settings;
    if (s.hero_stat_1_number && s.hero_stat_1_label) {
      return [
        [s.hero_stat_1_number, s.hero_stat_1_label],
        [s.hero_stat_2_number || 'Egypt & Gulf', s.hero_stat_2_label || 'Region'],
        [s.hero_stat_3_number || '18+', s.hero_stat_3_label || 'Expert Trainers'],
        [s.hero_stat_4_number || '4–5 Weeks', s.hero_stat_4_label || 'To Band 7+'],
      ];
    }
    return DEFAULT_STATS;
  })();

  const waNumber  = settings.whatsapp_number  || DEFAULT_WA;
  const waNumber2 = settings.whatsapp_number_2 || null;

  // branding prop (from App.js Supabase fetch) takes priority; settings is the local fallback
  const effectiveLogoUrl    = branding?.logo_url || settings.logo_url;
  const effectiveAcademyName = branding?.logo     || settings.academy_name;

  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',sans-serif", overflowX:'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700&family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600;1,700&family=JetBrains+Mono:wght@400;500;600;700&display=swap');
        * { margin:0; padding:0; box-sizing:border-box; }
        html { scroll-behavior:smooth; }
        input::placeholder, textarea::placeholder { color:rgba(255,255,255,0.45) !important; }
        @media (max-width: 700px) {
          .lp-nav-links { display: none !important; }
          .lp-nav-actions { gap: 6px !important; }
          .lp-nav-actions button { padding: 7px 12px !important; font-size: 12px !important; }
        }
      `}</style>
      <NavBar onLogin={onLogin} onRegister={onRegister} onTrial={onTrial} onAcademy={onAcademy} logoUrl={effectiveLogoUrl} academyName={effectiveAcademyName}/>
      <HeroSection onTrial={onTrial} stats={heroStats}/>
      <HowItWorksSection/>
      <CoursesSection waNumber={waNumber}/>
      <ResultsSection results={results}/>
      <TestimonialsSection testimonials={testimonials}/>
      <ContactSection waNumber={waNumber} waNumber2={waNumber2}/>
      <Footer onTerms={onTerms} onPrivacy={onPrivacy} onAcademy={onAcademy} academyName={effectiveAcademyName}/>
    </div>
  );
}
